import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TypeSpecimenIcon(props: IconProps) {
    return <Icon {...props} iconKey={"type_specimen"}/>
}
